import React from 'react'
import { useAtom, useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { configFileAtom, editedConfigAtom } from './atoms'
import deepEqual from 'fast-deep-equal'
import { Box, Button } from '@mui/material'
import { useSaveEditedConfig } from './hooks'
import { NavigationBlock } from 'shared/ui/NavigationBlock'

export function ConfigChanges() {
  const currentConfig = useAtomValue(configFileAtom)
  const [editedConfig, setEditingConfig] = useAtom(editedConfigAtom)
  const saveChanges = useSaveEditedConfig()

  const areEqual = deepEqual(currentConfig, editedConfig)

  return (
    <Box>
      <Button disabled={areEqual} onClick={saveChanges}>
        Save Changes
      </Button>
      <NavigationBlock
        shouldBlock={!areEqual}
        onProceedAnyway={() => setEditingConfig(currentConfig)}
      >
        <Box>You have unsaved changes.</Box>
      </NavigationBlock>
    </Box>
  )
}
